import { API_URL, AUTH_API_URL } from "../config/apiConfig";

export const authService = {
  async requestMagicLink(email) {
    try {
      const response = await fetch(`${AUTH_API_URL}/auth/magic-link`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (!response.ok) {
        if (data.requiresSubscription) {
          return { 
            success: false, 
            requiresSubscription: true, 
            redirectTo: data.redirectTo || '/assinar',
            error: data.error 
          };
        }
        throw new Error(data.error || "Erro ao enviar link");
      }

      return { success: true, message: data.message };
    } catch (error) {
      console.error("Erro ao solicitar magic link:", error.message);
      throw error;
    }
  },

  async verifyMagicLink(token) {
    try {
      const response = await fetch(`${AUTH_API_URL}/auth/verify-magic-link?token=${token}`);
      const data = await response.json();

      if (!response.ok) {
        if (data.requiresSubscription) {
          return { 
            success: false, 
            requiresSubscription: true, 
            error: data.error 
          };
        }
        throw new Error(data.error || "Link inválido ou expirado");
      }

      localStorage.setItem("token", data.token);
      localStorage.setItem("email", data.user.email);
      localStorage.setItem("username", data.user.username);
      localStorage.setItem("userId", data.user.id);
      localStorage.setItem("subscriptionStatus", data.user.subscriptionStatus);
      localStorage.setItem("plan", data.user.plan || '');
      localStorage.setItem("loginTimestamp", Date.now().toString());

      return { success: true, user: data.user };
    } catch (error) {
      console.error("Erro ao verificar magic link:", error.message);
      throw error;
    }
  },

  async login(email, password) {
    try {
      console.log("Iniciando processo de login...");
      
      const response = await fetch(`${AUTH_API_URL}/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (!response.ok) {
        if (data.requiresSubscription) {
          return { 
            success: false, 
            requiresSubscription: true, 
            redirectTo: data.redirectTo || '/assinar',
            error: data.error 
          };
        }
        throw new Error(data.error || "Erro na autenticação");
      }

      localStorage.setItem("token", data.token);
      localStorage.setItem("email", data.user.email);
      localStorage.setItem("username", data.user.username);
      localStorage.setItem("userId", data.user.id);
      localStorage.setItem("subscriptionStatus", data.user.subscriptionStatus);
      localStorage.setItem("plan", data.user.plan || '');
      localStorage.setItem("loginTimestamp", Date.now().toString());

      return { success: true, user: data.user };
    } catch (error) {
      console.error("Erro na autenticação:", error.message);
      throw error;
    }
  },

  async checkSubscriptionStatus() {
    try {
      const token = localStorage.getItem("token");
      if (!token) return { isActive: false };

      const response = await fetch(`${AUTH_API_URL}/auth/me`, {
        headers: {
          "Authorization": `Bearer ${token}`
        }
      });

      if (!response.ok) {
        this.logout();
        return { isActive: false };
      }

      const data = await response.json();
      
      if (data.subscriptionStatus !== 'active') {
        this.logout();
        return { isActive: false, reason: 'subscription_inactive' };
      }

      localStorage.setItem("subscriptionStatus", data.subscriptionStatus);
      localStorage.setItem("plan", data.plan || '');

      return { isActive: true, user: data };
    } catch (error) {
      console.error("Erro ao verificar assinatura:", error);
      return { isActive: false };
    }
  },

  isTokenValid() {
    const token = localStorage.getItem("token");
    const loginTimestamp = localStorage.getItem("loginTimestamp");
    const subscriptionStatus = localStorage.getItem("subscriptionStatus");

    if (!token || !loginTimestamp) {
      return false;
    }

    if (subscriptionStatus !== 'active') {
      this.logout();
      return false;
    }

    const expirationTime = 24 * 60 * 60 * 1000;
    const currentTime = Date.now();
    const timeSinceLogin = currentTime - parseInt(loginTimestamp);

    if (timeSinceLogin > expirationTime) {
      this.logout();
      return false;
    }

    return true;
  },

  logout() {
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    localStorage.removeItem("email");
    localStorage.removeItem("userId");
    localStorage.removeItem("loginTimestamp");
    localStorage.removeItem("subscriptionStatus");
    localStorage.removeItem("plan");
  },

  isAuthenticated() {
    return this.isTokenValid() && localStorage.getItem("subscriptionStatus") === 'active';
  }
};
